import React, { useEffect, useState } from 'react';
import * as MUI from '@mui/material';
import { InputGroup, TextField } from '../../../../../../Styles';

const TurnaroundTime = ({ label = 'Turnaround Time(TAT)', value = '', error = '', required = false, disabled = false, onChange = null, onError = null }) => {
	const [inputValue, setInputValue] = useState(value);

	const validate = () => {
		let error = null;

		if (inputValue && inputValue !== '') {
			const parsedValue = parseInt(inputValue, 10);
			if (isNaN(parsedValue)) {
				error = `${label} must be a whole number.`;
			} else if (parsedValue <= 0) {
				error = `${label} must be a whole number greater than 1.`;
			}
		}

		onError(error);
		return !error;
	};

	useEffect(() => {
		validate();
		if (onChange) {
			onChange(inputValue);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inputValue]);

	useEffect(() => {
		setInputValue(value);
	}, [value]);

	return (
		<InputGroup
			label={label}
			markRequired={required}
			error={error}
		>
			<TextField
				name={'turnaround_time'}
				placeholder='Enter'
				value={inputValue}
				disabled={disabled}
				onChange={(e) => {
					const value = e.target.value.replace(/[^0-9]/g, '');
					setInputValue(value);
				}}
				onPaste={(e) => {
					e.preventDefault();
					const paste = (e.clipboardData || window.clipboardData).getData('text');
					const numericValue = paste.replace(/[^0-9]/g, '');
					setInputValue(numericValue);
				}}
				endAdornment={
					<MUI.InputAdornment position="end" style={{ paddingRight: '0.5rem' }}>
						Days
					</MUI.InputAdornment>
				}
				error={error}
			/>
		</InputGroup>
	);
};

export default TurnaroundTime;

